import { Action } from 'redux'
import { isType } from 'ts-action'
import { IChallengesReducer, IChallenge } from '../../models/Challenge'
import { updateArray, deleteFromArray } from '../../helpers/helperFunctions'
import { GetChallenges, ChallengesFetching, UpdateChallenge, DeleteChallenge } from './actions'

const initialState: IChallengesReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const challengesReducer = (state = initialState, action: Action): IChallengesReducer => {
  if (isType(action, GetChallenges)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, UpdateChallenge)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IChallenge>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeleteChallenge)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IChallenge>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, ChallengesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
